import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

const categories = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
  { name: 'Hoodies / Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
  { name: 'Pants / Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html' },
  { name: 'Underwear / Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html' },
];

const shoppingGuides = [
  { label: 'Sugargoo Review', href: '/sugargoo-review-2026' },
  { label: 'Shipping Cost Guide', href: '/sugargoo-shipping-cost-guide' },
  { label: 'Coupon & Discounts', href: '/sugargoo-coupon-discount-guide' },
  { label: 'Warehouse Guide', href: '/sugargoo-warehouse-guide' },
  { label: 'Is Sugargoo Legit?', href: '/is-sugargoo-legit' },
  { label: 'Beginner Guide', href: '/sugargoo-spreadsheet-beginners' },
  { label: 'Shoes Finds', href: '/sugargoo-spreadsheet-shoes-finds' },
  { label: 'Alternatives Comparison', href: '/sugargoo-vs-alternatives' },
  { label: 'QC Photos Guide', href: '/sugargoo-qc-photos-guide' },
];

const navLinks = [
  { label: 'Home', href: '/' },
  { label: 'Ultimate Guide', href: '/sugargoo-spreadsheet-ultimate-guide' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [guideOpen, setGuideOpen] = useState(false);
  const [mobileGuideOpen, setMobileGuideOpen] = useState(false);
  const [mobileCatOpen, setMobileCatOpen] = useState(false);
  const guideRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => { setScrolled(window.scrollY > 60); };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (guideRef.current && !guideRef.current.contains(e.target as Node)) {
        setGuideOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-[4.5rem]">
          <Link to="/" className="flex items-center gap-2">
            <span className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 whitespace-nowrap">
              Sugargoo<span className="text-primary-500">Spreadsheet</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-6">
            {navLinks.map((link) => (
              <Link key={link.label} to={link.href} className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                {link.label}
              </Link>
            ))}

            <div className="relative" ref={guideRef}>
              <button
                onClick={() => setGuideOpen(!guideOpen)}
                className="flex items-center gap-1.5 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
              >
                Shopping Guide
                <i className={`ri-arrow-down-s-line text-sm transition-transform duration-200 ${guideOpen ? 'rotate-180' : ''}`}></i>
              </button>
              {guideOpen && (
                <div className="absolute top-full mt-2 right-0 w-56 bg-background-50 rounded-xl border border-background-200/80 shadow-lg py-2 z-50">
                  {shoppingGuides.map((guide) => (
                    <Link
                      key={guide.href}
                      to={guide.href}
                      onClick={() => setGuideOpen(false)}
                      className="block px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-500 transition-colors duration-150 whitespace-nowrap"
                    >
                      {guide.label}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="inline-flex items-center px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-semibold rounded-full transition-all duration-200 whitespace-nowrap">
              Visit Main Site <i className="ri-arrow-right-up-line ml-1.5"></i>
            </a>
          </div>

          <button className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-800" onClick={() => setMobileOpen(!mobileOpen)} aria-label="Toggle menu">
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60 max-h-[80vh] overflow-y-auto">
          <div className="px-6 py-4 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link key={link.label} to={link.href} onClick={() => setMobileOpen(false)} className="flex items-center gap-2 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors py-2.5">
                <i className="ri-home-line text-base"></i>
                {link.label}
              </Link>
            ))}

            <button onClick={() => setMobileGuideOpen(!mobileGuideOpen)} className="flex items-center justify-between w-full text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors py-2.5">
              <span className="flex items-center gap-2">
                <i className="ri-book-open-line text-base"></i>
                Shopping Guide
              </span>
              <i className={`ri-arrow-down-s-line text-base transition-transform duration-200 ${mobileGuideOpen ? 'rotate-180' : ''}`}></i>
            </button>
            {mobileGuideOpen && (
              <div className="ml-6 border-l-2 border-background-200 pl-4 py-1 space-y-1">
                {shoppingGuides.map((guide) => (
                  <Link key={guide.href} to={guide.href} onClick={() => setMobileOpen(false)} className="block text-sm text-foreground-600 hover:text-primary-500 transition-colors py-1.5">
                    {guide.label}
                  </Link>
                ))}
              </div>
            )}

            <button onClick={() => setMobileCatOpen(!mobileCatOpen)} className="flex items-center justify-between w-full text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors py-2.5">
              <span className="flex items-center gap-2">
                <i className="ri-grid-line text-base"></i>
                Categories
              </span>
              <i className={`ri-arrow-down-s-line text-base transition-transform duration-200 ${mobileCatOpen ? 'rotate-180' : ''}`}></i>
            </button>
            {mobileCatOpen && (
              <div className="ml-6 border-l-2 border-background-200 pl-4 py-1 grid grid-cols-2 gap-x-3 gap-y-1">
                {categories.map((cat) => (
                  <a key={cat.name} href={cat.url} target="_blank" rel="noopener nofollow" onClick={() => setMobileOpen(false)} className="block text-xs text-foreground-600 hover:text-primary-500 transition-colors py-1.5 whitespace-nowrap">
                    {cat.name}
                  </a>
                ))}
              </div>
            )}

            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="flex items-center justify-center gap-2 mt-3 px-5 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-semibold rounded-full transition-all duration-200 whitespace-nowrap">
              Visit Main Site <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}